<template>
  <!-- START FOOTER -->
  <div class="container-fluid container-fixed-lg footer">
    <div class="copyright sm-text-center">
      <p class="small no-margin pull-left sm-pull-reset">
        <span class="hint-text">Copyright © 2016</span>
        <span class="font-montserrat"><a :href="client.website" target="_blank">{{client.name}}</a></span>.
        <span class="hint-text m-r-5">All rights reserved</span>
        <span class="sm-block">|<router-link :to="'/debug'"  class="m-l-5 m-r-5">Infos Version</router-link></span>
      </p>
      <p class="small no-margin pull-right sm-pull-reset">
        Hand-crafted
        <span class="hint-text">&amp; Made with <span class="glyphicon glyphicon-heart" aria-hidden="true"></span> by </span>
        <span class="font-montserrat"><a :href="author.website" target="_blank">{{author.name}}</a></span>
      </p>
      <div class="clearfix"></div>
    </div>
  </div>
  <!-- END FOOTER -->
</template>

<script>
export default {
  data () {
    return {
      client: {
        name: 'SOFRADOM',
        website: 'https://www.sofradom.fr'
      },
      author: {
        name: 'HelloMojito',
        website: 'http://www.hellomojito.com'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// client/components/Footer.vue